import { render, staticRenderFns } from "./PaginationTemplates.vue?vue&type=template&id=75d4577c&scoped=true&"
import script from "./PaginationTemplates.vue?vue&type=script&lang=ts&"
export * from "./PaginationTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d4577c",
  null
  
)

export default component.exports